function getProgressBarCartTotal(cart) {
    if (!cart) return 0;
    const managed = item => window.ChicCartRewards?.managedGift(item) || item?.properties?._shipping_bar_gift === '1' || item?.properties?._gift_block_cart === '1';
    const productLine = item => Math.max(0, Number(item?.original_line_price || 0) - (item?.line_level_discount_allocations || []).reduce((sum, allocation) => sum + Number(allocation.amount || 0), 0));
    const total = Number.isSafeInteger(cart.items_subtotal_price) ? cart.items_subtotal_price : (cart.items || []).reduce((sum, item) => sum + productLine(item), 0);
    return Math.max(0, total - (cart.items || []).reduce((sum, item) => sum + (managed(item) ? productLine(item) : 0), 0));
}
window.getProgressBarCartTotal = getProgressBarCartTotal;

(() => {
    if (window.ChicCartRewards) return;
    let state = null;
    let running = null;
    let rerun = false;
    let blockedSignature = null;
    let safe = true;
    let publishingCart = false;
    const managedGift = item => item?.managedGift === true || ['1', 1].includes(item?.properties?._shipping_bar_gift) || ['1', 1].includes(item?.properties?._gift_block_cart);
    const cartURL = suffix => {
        const url = new URL(window.routes?.cart_url || '/cart', location.origin);
        url.pathname = url.pathname.replace(/\/?$/, suffix || '');
        url.search = '';
        return url;
    };
    const signature = snapshot => JSON.stringify([snapshot.enabled, snapshot.currency, snapshot.country, snapshot.otherOfferActive, snapshot.giftEnabled, snapshot.giftAvailable, snapshot.physicalGiftStock, snapshot.lines.filter(line => !line.managedGift).map(line => [line.variantId, line.quantity, line.originalPrice, line.originalLinePrice, line.eligibleGiftLine]).sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right)))]);
    function normalize(raw) {
        if (!raw || typeof raw.enabled !== 'boolean' || typeof raw.currency !== 'string' || typeof raw.country !== 'string' || !Array.isArray(raw.lines) || !raw.lines.every(line => typeof line.key === 'string' && /^\d+$/.test(String(line.variantId)) && Number.isInteger(line.quantity) && line.quantity > 0 && Number.isSafeInteger(line.finalLinePrice) && line.finalLinePrice >= 0)) throw new Error('Invalid reward cart snapshot');
        for (const name of ['shippingSpendCents', 'eligibleGiftSpendCents', 'shippingThresholdCents', 'giftThresholdCents', 'cartWeight', 'physicalGiftStock', 'shippingMaxGrams', 'orderSpendCents', 'orderDiscountCents', 'orderAppliedPercent']) if (!Number.isFinite(raw[name]) || raw[name] < 0 && name !== 'physicalGiftStock') throw new Error('Invalid reward amount');
        if (raw.giftVariantId !== '67737270878487' || raw.shippingThresholdCents !== 9500 || raw.giftThresholdCents !== 15000 || raw.shippingMaxGrams !== 2267.96185 || typeof raw.giftEnabled !== 'boolean' || typeof raw.giftAvailable !== 'boolean' || ![0, 10, 20].includes(raw.orderAppliedPercent) || !raw.strings) throw new Error('Unknown cart reward campaign');
        return raw;
    }
    function decorated(raw) {
        const enabled = raw.enabled && raw.currency === 'USD';
        const giftEnabled = raw.giftEnabled && raw.giftAvailable && raw.physicalGiftStock > 0;
        const giftQualified = enabled && giftEnabled && raw.eligibleGiftSpendCents >= raw.giftThresholdCents && !raw.otherOfferActive;
        const shippingAvailable = enabled && raw.country === 'US' && raw.cartWeight <= raw.shippingMaxGrams && !raw.otherOfferActive;
        const shippingUnlocked = shippingAvailable && raw.shippingSpendCents >= raw.shippingThresholdCents;
        const freeGift = raw.lines.some(line => line.giftSku && (line.managedGift ? line.quantity === 1 && line.finalLinePrice === 0 : line.originalPrice > 0 && line.originalLinePrice - line.finalLinePrice >= line.originalPrice));
        const blocked = blockedSignature === signature(raw);
        const giftUnlocked = giftQualified && raw.giftAvailable === true && freeGift;
        const availabilityError = enabled && giftEnabled && raw.eligibleGiftSpendCents >= raw.giftThresholdCents && (raw.giftAvailable !== true || raw.otherOfferActive || blocked);
        const status = !enabled ? 'not-applicable' : availabilityError ? 'unavailable' : giftUnlocked ? 'included' : giftQualified ? 'adding' : 'ready';
        const errorMessage = availabilityError ? raw.giftAvailable !== true ? raw.strings.giftStockUnavailable : raw.strings.giftOfferUnavailable : '';
        const orderEligiblePercent = enabled ? raw.orderSpendCents >= 35000 ? 20 : raw.orderSpendCents >= 22500 ? 10 : 0 : 0;
        const orderAppliedPercent = enabled && raw.orderDiscountCents > 0 ? raw.orderAppliedPercent : 0;
        return { ...raw, giftEnabled, orderAppliedPercent, orderEligiblePercent, giftQualified, shippingAvailable, shippingUnlocked, giftUnlocked, availabilityError, status, errorMessage };
    }
    function publishState(raw) {
        state = decorated(normalize(raw));
        document.dispatchEvent(new CustomEvent('chic:rewards-updated', { detail: state }));
        document.querySelectorAll('shipping-bar').forEach(bar => bar.update());
        updateSummaries();
        return state;
    }
    function updateSummaries() {
        document.querySelectorAll('[data-chic-reward-summary]').forEach(summary => {
            if (summary.closest('cart-slide')) return;
            const refreshFailed = state?.errorMessage === state?.strings?.rewardsUnavailable;
            const shipping = summary.querySelector('[data-chic-shipping-confirmation]');
            const discount = summary.querySelector('[data-chic-order-confirmation]');
            if (shipping) shipping.hidden = !state?.lines?.length || !state?.shippingUnlocked || refreshFailed;
            if (discount) {
                discount.hidden = !state?.lines?.length || !state?.orderAppliedPercent || refreshFailed;
                const value = discount.querySelector('[data-chic-order-status]');
                if (value && state?.strings?.orderApplied) value.textContent = '✓ ' + state.strings.orderApplied.replace('__percent__', state.orderAppliedPercent);
            }
        });
    }
    async function json(url, body, liquidView = false) {
        const response = await fetch(String(url), { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: liquidView ? 'text/html' : 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || state?.strings?.rewardsUnavailable || 'Please refresh your cart.');
        return payload;
    }
    async function load() {
        const url = cartURL();
        url.searchParams.set('view', 'chic-rewards');
        return publishState(await json(url, null, true));
    }
    async function refreshPageCart() {
        const root = document.querySelector('.main-cart[data-section-id]');
        if (!root) return;
        const target = root.querySelector('[data-line-items-container]');
        if (!target) return;
        const note = target.querySelector('textarea[name="note"]')?.value;
        const url = new URL(location.href);
        url.searchParams.delete('view');
        url.searchParams.set('sections', root.dataset.sectionId);
        const sections = await json(url, null, true);
        const html = sections[root.dataset.sectionId];
        if (typeof html !== 'string') throw new Error('CHIC reward section response is missing');
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-line-items-container]');
        if (!source) throw new Error('CHIC reward cart section content is missing');
        target.innerHTML = source.innerHTML;
        if (note !== undefined && target.querySelector('textarea[name="note"]')) target.querySelector('textarea[name="note"]').value = note;
    }
    async function publishCart(refreshPage = true) {
        const cart = await json(cartURL('.js'));
        publishingCart = true;
        try {
            if (window.VanillaCartState?.updateCart) window.VanillaCartState.updateCart(cart);
            else document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        } finally { publishingCart = false; }
        if (refreshPage) await refreshPageCart();
        updateSummaries();
    }
    async function change(key, quantity) {
        await json(cartURL('/change.js'), { id: key, quantity });
        await publishCart();
    }
    async function reconcile() {
        let maximumAttempts = 12;
        for (let attempt = 0; attempt < maximumAttempts; attempt++) {
            const current = await load();
            maximumAttempts = Math.max(maximumAttempts, current.lines.length + 12);
            const upfrontPreorder = current.enabled && current.currency === 'USD' && current.lines.find(line => line.upfrontPreorderAllocation === true);
            if (upfrontPreorder) {
                await json(cartURL('/change.js'), { id: upfrontPreorder.key, quantity: upfrontPreorder.quantity, selling_plan: null });
                await publishCart();
                continue;
            }
            const managed = current.lines.filter(line => line.managedGift);
            const selectedManaged = managed.filter(line => line.giftSku);
            const manual = current.lines.some(line => line.giftSku && !line.managedGift);
            const canGift = current.giftQualified && current.giftAvailable === true && blockedSignature !== signature(current);
            const obsolete = managed.find(line => !line.giftSku || !canGift || manual);
            if (obsolete) { await change(obsolete.key, 0); continue; }
            if (selectedManaged.length > 1) { await change(selectedManaged[selectedManaged.length - 1].key, 0); continue; }
            if (selectedManaged[0]?.quantity > 1) { await change(selectedManaged[0].key, 1); continue; }
            if (selectedManaged[0] && selectedManaged[0].finalLinePrice !== 0) {
                blockedSignature = signature(current);
                await change(selectedManaged[0].key, 0);
                continue;
            }
            if (!selectedManaged.length && canGift && !manual) {
                try {
                    await json(cartURL('/add.js'), { items: [{ id: current.giftVariantId, quantity: 1, properties: { _shipping_bar_gift: '1', _chic_cart_reward: 'gift-bag-150-v1' } }] });
                } catch (error) {
                    blockedSignature = signature(current);
                    await load();
                    continue;
                }
                await publishCart();
                continue;
            }
            if (manual && current.giftQualified && !current.giftUnlocked) {
                blockedSignature = signature(current);
                publishState(current);
            }
            await publishCart(false);
            document.dispatchEvent(new CustomEvent('chic:rewards-updated', { detail: state }));
            return !current.lines.some(line => line.managedGift && line.finalLinePrice !== 0);
        }
        throw new Error('CHIC reward cart did not settle after ' + maximumAttempts + ' reconciliation attempts');
    }
    async function run() {
        try {
            do { rerun = false; safe = await reconcile(); } while (rerun);
            return safe;
        } catch (error) {
            console.warn('CHIC cart reward reconciliation failed:', error.stack || error.message);
            safe = false;
            if (state) {
                state = { ...state, status: 'unavailable', availabilityError: true, errorMessage: state.strings.rewardsUnavailable };
                document.dispatchEvent(new CustomEvent('chic:rewards-updated', { detail: state }));
            }
            return false;
        }
    }
    function sync() {
        rerun = true;
        if (!running) running = run().finally(() => { running = null; });
        return running;
    }
    function pendingCartEdits() {
        if ([...document.querySelectorAll('cart-slide')].some(drawer => drawer._quantityUpdateInProgress?.size > 0)) return true;
        return [...document.querySelectorAll('line-item-qty')].some(control => {
            if (control._updateInProgress || control._buttonClickInProgress) return true;
            const input = control.querySelector('[name="updates[]"]');
            const initial = control.closest('.line-item[data-init-qty]')?.dataset.initQty;
            return input && initial !== undefined && Number.isFinite(Number(input.value)) && Number(input.value) !== Number(initial);
        });
    }
    async function ensure() {
        for (let attempt = 0; attempt < 100 && pendingCartEdits(); attempt++) await new Promise(resolve => setTimeout(resolve, 100));
        if (pendingCartEdits()) {
            safe = false;
            if (state) {
                state = { ...state, status: 'unavailable', availabilityError: true, errorMessage: state.strings.rewardsUnavailable };
                document.dispatchEvent(new CustomEvent('chic:rewards-updated', { detail: state }));
            }
            return false;
        }
        // A validation read waits for active reconciliation without requesting another pass.
        return running || sync();
    }
    const matchesCart = cart => state && Array.isArray(cart?.items) && cart.items.length === state.lines.length && cart.items.every(item => state.lines.some(line => line.key === item.key && line.quantity === item.quantity && line.originalLinePrice === item.original_line_price && line.finalLinePrice === item.final_line_price));
    window.ChicCartRewards = { snapshot: () => state, sync, ensure, managedGift, shippingSpend: getProgressBarCartTotal, giftSpend: cart => !cart || matchesCart(cart) ? state?.eligibleGiftSpendCents || 0 : 0 };
    const initial = document.querySelector('[data-chic-cart-rewards-state]');
    if (initial) { try { state = decorated(normalize(JSON.parse(initial.textContent))); } catch (_) {} }
    document.addEventListener('cart:updated', () => { document.querySelectorAll('[data-chic-reward-summary] [role="status"]').forEach(row => { row.hidden = true; }); if (!publishingCart) sync(); });
    document.addEventListener('shopify:section:load', () => { sync(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { sync(); }, { once: true });
    else sync();
})();

if (!customElements.get('shipping-bar')) {
    customElements.define('shipping-bar', class ShippingBar extends HTMLElement {
        static get observedAttributes() {
            return ['data-cart-totals'];
        }

        connectedCallback() {
            this.update();
            this._onResize = () => {
                if (typeof this.setBar === 'function') this.setBar();
            };
            window.addEventListener('resize', this._onResize);
            setTimeout(() => {
                if (typeof this.syncShippingBarGifts === 'function') {
                    this.syncShippingBarGifts();
                }
            }, 500);
        }

        disconnectedCallback() {
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
            }
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-cart-totals' && oldValue !== newValue) {
                this.update();
            }
        }

        update() {
            this.calculateAndRender();
        }

        calculateAndRender() {
            const reward = window.ChicCartRewards?.snapshot();
            const cartContext = this.closest('cart-slide') || this.closest('.main-cart');
            const textContainer = cartContext ? cartContext.querySelector('[data-shipping-bar-text]') : document.querySelector('[data-shipping-bar-text]');
            const wrapper = this.closest('.shipping-bar-wrapper');
            if (!reward || !reward.enabled || reward.currency !== 'USD') {
                if (wrapper) wrapper.hidden = true;
                if (textContainer) textContainer.hidden = true;
                return;
            }
            if (wrapper) wrapper.hidden = false;
            if (textContainer) textContainer.hidden = false;
            const visible = milestone => milestone.goalType === 'shipping' ? reward.country === 'US' : milestone.goalType !== 'gift' || reward.giftEnabled;
            this.querySelectorAll('.cart-slide__label').forEach(label => { label.hidden = !visible({ goalType: label.dataset.goalType }); });
            const milestones = this.getMilestones().filter(visible);
            if (!milestones.length) return;
            const reached = milestone => milestone.goalType === 'gift' ? reward.giftUnlocked : milestone.goalType === 'shipping' ? reward.shippingUnlocked : reward.orderAppliedPercent >= milestone.discountPercent;
            const spend = milestone => (milestone.goalType === 'gift' ? reward.eligibleGiftSpendCents : milestone.goalType === 'discount' ? reward.orderSpendCents : reward.shippingSpendCents) / 100;
            const applicable = milestone => milestone.goalType === 'gift' ? reward.giftAvailable && !reward.otherOfferActive : milestone.goalType === 'shipping' ? reward.shippingAvailable : true;
            const next = milestones.find(milestone => applicable(milestone) && !reached(milestone) && spend(milestone) < milestone.price);
            const moneyFormat = this.dataset.moneyFormat || window.money_format;
            let message = '';
            if (reward.orderAppliedPercent) message = reward.strings.orderApplied.replace('__percent__', reward.orderAppliedPercent) + '.';
            else if (reward.orderEligiblePercent) message = reward.otherOfferActive ? reward.strings.bestOffer : reward.strings.orderPending;
            else if (reward.giftUnlocked) message = reward.strings.giftIncluded;
            else if (reward.status === 'adding') message = reward.strings.giftAdding;
            if (next) {
                const remaining = Math.max(0, Math.round((next.price - spend(next)) * 100));
                message += (message ? ' ' : '') + this.buildMessageFromTemplate(next.progressText, this.formatRewardMoney(remaining, moneyFormat), next.label);
            } else if (!message && reward.shippingUnlocked) message = reward.strings.shippingIncluded;
            else if (!message && !reward.shippingAvailable && reward.country === 'US') message = reward.strings.shippingUnavailable;
            if (reward.availabilityError) message += ' ' + reward.errorMessage;
            if (textContainer) {
                textContainer.innerHTML = message || '';
                textContainer.style.fontWeight = reward.orderAppliedPercent ? '600' : '400';
            }
            this.classList.toggle('shipping-unlocked', reward.shippingUnlocked);
            wrapper?.classList.toggle('shipping-unlocked', reward.shippingUnlocked);
            this.threshold = Math.min(...milestones.map(milestone => milestone.price));
            this.cartTotals = reward.orderSpendCents / 100;
            this.setBar();
        }

        updateCartTotals(cartTotalPrice) {
            if (cartTotalPrice === undefined || cartTotalPrice === null) {
                return;
            }
            this.dataset.cartTotals = String(cartTotalPrice);
        }

        updateFromCart(cart) {
            this.updateCartTotals(getProgressBarCartTotal(cart));
        }

        setBar() {
            const element = this.querySelector('[data-progress-span]');
            if (!element) return;

            if (!this.threshold || this.threshold <= 0) return;

            const marks = this.querySelectorAll('.cart-slide__label:not([hidden])');
            const maxThreshold = this.getMaxThreshold(marks);
            if (!maxThreshold || maxThreshold <= 0) return;

            this.updateReachedLabels();
            // Place icons first, then fill must follow the same visual positions
            this.positionIcons();

            let value = this.getFillPercentFromIcons(marks);
            if (value > 100) value = 100;
            if (value < 0) value = 0;

            element.setAttribute('data-value', value.toFixed(2));
            element.style.setProperty('--bar-width', `${value.toFixed(2)}%`);
            element.textContent = value.toFixed(2);
        }

        /**
         * Fill % based on actual icon centers so the line matches milestones
         * (including first/last pins and 80px min-gap shifts).
         */
        getFillPercentFromIcons(marks) {
            const barWidth = this.offsetWidth || 1;
            const cartTotals = this.cartTotals || 0;
            if (cartTotals <= 0 || barWidth <= 0) return 0;

            const barLeft = this.getBoundingClientRect().left;
            const points = Array.from(marks)
                .map((mark) => {
                    const price = parseFloat(mark.dataset.price);
                    const icon = mark.querySelector('i') || mark;
                    const rect = icon.getBoundingClientRect();
                    return {
                        price,
                        center: rect.left + rect.width / 2 - barLeft
                    };
                })
                .filter((p) => !isNaN(p.price) && p.price > 0)
                .sort((a, b) => a.price - b.price);

            if (points.length === 0) {
                const fallbackMax = this.getMaxThreshold(marks) || 1;
                return Math.min(100, (cartTotals / fallbackMax) * 100);
            }

            const first = points[0];
            const last = points[points.length - 1];

            if (cartTotals >= last.price) return 100;

            if (cartTotals <= first.price) {
                const pct = first.center * (cartTotals / first.price);
                return Math.max(0, Math.min(100, (pct / barWidth) * 100));
            }

            for (let i = 0; i < points.length - 1; i++) {
                const a = points[i];
                const b = points[i + 1];
                if (cartTotals >= a.price && cartTotals <= b.price) {
                    const span = Math.max(0.0001, b.price - a.price);
                    const ratio = (cartTotals - a.price) / span;
                    const fillPx = a.center + ratio * (b.center - a.center);
                    return Math.max(0, Math.min(100, (fillPx / barWidth) * 100));
                }
            }

            return Math.min(100, (cartTotals / last.price) * 100);
        }

        updateReachedLabels() {
            const reward = window.ChicCartRewards?.snapshot();
            this.querySelectorAll('.cart-slide__label').forEach(label => {
                const reached = label.dataset.goalType === 'gift' ? reward?.giftUnlocked : label.dataset.goalType === 'shipping' ? reward?.shippingUnlocked : Boolean(reward?.orderAppliedPercent && reward.orderAppliedPercent >= Number(label.dataset.discountPercent || 0));
                label.classList.toggle('is-reached', Boolean(reached));
            });
        }

        getMaxThreshold(labels) {
            let maxThreshold = this.threshold;
            labels.forEach(label => {
                const price = parseFloat(label.dataset.price);
                if (!isNaN(price) && price > maxThreshold) {
                    maxThreshold = price;
                }
            });
            return maxThreshold;
        }

        getMinThreshold(labels) {
            let minThreshold = NaN;
            labels.forEach(label => {
                const price = parseFloat(label.dataset.price);
                if (!isNaN(price) && price > 0) {
                    minThreshold = isNaN(minThreshold) ? price : Math.min(minThreshold, price);
                }
            });
            if (isNaN(minThreshold)) {
                minThreshold = parseFloat(this.threshold) || 0;
            }
            return minThreshold;
        }

        getTrackLayout() {
            const barWidth = this.offsetWidth || 1;
            const insetPx = 18;
            const leftPct = Math.min(12, (insetPx / barWidth) * 100);
            const rightPct = Math.min(14, (insetPx / barWidth) * 100);
            return {
                leftPct,
                rightPct,
                rangePct: Math.max(0, 100 - leftPct - rightPct)
            };
        }

        positionOnTrack(price, minThreshold, maxThreshold) {
            const { leftPct, rangePct } = this.getTrackLayout();
            if (maxThreshold <= minThreshold) {
                return leftPct + rangePct;
            }
            const ratio = (price - minThreshold) / (maxThreshold - minThreshold);
            return leftPct + Math.max(0, Math.min(1, ratio)) * rangePct;
        }

        fillOnTrack(cartTotals, minThreshold, maxThreshold) {
            const { leftPct, rangePct } = this.getTrackLayout();
            if (cartTotals <= 0) return 0;
            if (maxThreshold <= minThreshold) {
                return (cartTotals / maxThreshold) * 100;
            }
            if (cartTotals < minThreshold) {
                return leftPct * (cartTotals / minThreshold);
            }
            const ratio = (cartTotals - minThreshold) / (maxThreshold - minThreshold);
            return leftPct + Math.min(1, ratio) * rangePct;
        }

        getMilestones() {
            return Array.from(this.querySelectorAll('.cart-slide__label'))
                .map(label => {
                    const price = parseFloat(label.dataset.price);
                    const titleEl = label.querySelector('.cart-slide__label-title');
                    const labelText = titleEl?.textContent?.trim()
                        || label.querySelector('p')?.textContent?.trim()
                        || '';
                    const goalType = (label.dataset.goalType || '').toLowerCase();
                    const order = parseInt(label.dataset.order, 10) || 999;
                    const progressText = label.dataset.progressText || '';
                    const giftVariantId = (label.dataset.giftVariantId || '').trim();
                    const discountPercent = Number(label.dataset.discountPercent || 0);
                    return { price, label: labelText, goalType, order, progressText, giftVariantId, discountPercent };
                })
                .filter(item => !isNaN(item.price) && item.price > 0)
                .sort((a, b) => a.order - b.order || a.price - b.price);
        }

        formatRewardMoney(amount, fallbackFormat) {
            const reward = window.ChicCartRewards?.snapshot();
            if (/^(pt|es)(-|$)/i.test(reward?.locale || document.documentElement.lang || '')) {
                return new Intl.NumberFormat(reward?.locale || document.documentElement.lang, { style: 'currency', currency: reward?.currency || 'USD' }).format(amount / 100);
            }
            return Shopify.formatMoney(amount, fallbackFormat);
        }

        buildMessageFromTemplate(template, formattedAmount, rewardLabel) {
            const safeTemplate = (template || '').trim();
            if (!safeTemplate) {
                const strings = window.ChicCartRewards?.snapshot()?.strings || {};
                return (strings.progressFallback || 'You’re ||amount|| away from ||label||').replace(/\|\|amount\|\|/g, formattedAmount).replace(/\|\|label\|\|/g, rewardLabel || strings.nextReward || 'next reward');
            }
            return safeTemplate
                .replace(/\|\|amount\|\|/g, formattedAmount)
                .replace(/\|\|label\|\|/g, rewardLabel || '');
        }

        getGiftMilestones() {
            return this.getMilestones().filter(milestone => milestone.goalType === 'gift' && milestone.giftVariantId);
        }

        syncShippingBarGifts() {
            return window.ChicCartRewards?.sync();
        }

        positionIcons() {
            const marks = Array.from(this.querySelectorAll('.cart-slide__label:not([hidden])'));
            if (marks.length === 0) return;

            const maxThreshold = this.getMaxThreshold(marks);
            const minThreshold = this.getMinThreshold(marks);
            if (!maxThreshold || maxThreshold <= 0) return;

            const sorted = [...marks].sort(
                (a, b) => (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0)
            );
            const firstMark = sorted[0];
            const lastMark = sorted[sorted.length - 1];
            const minGap = 80;
            const barWidth = this.offsetWidth || 1;

            // 1st + last: exact same as before — do not move
            sorted.forEach((mark) => {
                const textEl = mark.querySelector('.cart-slide__label-text');
                mark.style.position = 'absolute';
                mark.style.top = '0px';
                mark.style.right = 'auto';
                mark.style.left = '';
                mark.style.transform = '';
                if (textEl) {
                    textEl.style.transform = '';
                    textEl.style.textAlign = 'center';
                }
            });

            firstMark.style.left = '0';
            firstMark.style.right = 'auto';
            firstMark.style.transform = 'none';

            lastMark.style.left = 'auto';
            lastMark.style.right = '0';
            lastMark.style.transform = 'none';

            if (sorted.length === 1) {
                this.resolveLabelTextCollisions(sorted);
                return;
            }

            // Measure pinned end centers after layout
            const barLeft = this.getBoundingClientRect().left;
            const firstIcon = firstMark.querySelector('i') || firstMark;
            const lastIcon = lastMark.querySelector('i') || lastMark;
            const firstRect = firstIcon.getBoundingClientRect();
            const lastRect = lastIcon.getBoundingClientRect();
            const firstCenter = firstRect.left + firstRect.width / 2 - barLeft;
            const lastCenter = lastRect.left + lastRect.width / 2 - barLeft;
            const usable = Math.max(0, lastCenter - firstCenter);

            const prices = sorted.map((mark) => parseFloat(mark.dataset.price) || 0);
            const firstPrice = prices[0];
            const lastPrice = prices[prices.length - 1];
            const priceSpan = Math.max(0, lastPrice - firstPrice);

            // Inner marks only: spend-based, then enforce min 80px gap
            if (sorted.length > 2) {
                const centers = prices.map((price, index) => {
                    if (index === 0) return firstCenter;
                    if (index === prices.length - 1) return lastCenter;
                    if (priceSpan <= 0) {
                        return firstCenter + (usable * index) / (prices.length - 1);
                    }
                    const ratio = (price - firstPrice) / priceSpan;
                    return firstCenter + Math.max(0, Math.min(1, ratio)) * usable;
                });

                // Push inners right if too close to previous
                for (let i = 1; i < centers.length - 1; i++) {
                    centers[i] = Math.max(centers[i], centers[i - 1] + minGap);
                }

                // Pull inners left if too close to next / pinned last
                for (let i = centers.length - 2; i >= 1; i--) {
                    centers[i] = Math.min(centers[i], centers[i + 1] - minGap);
                    centers[i] = Math.max(centers[i], centers[i - 1] + minGap);
                }

                // If still can't fit min gaps between pinned ends, space inners evenly
                const needed = (sorted.length - 1) * minGap;
                if (needed > usable) {
                    for (let i = 1; i < centers.length - 1; i++) {
                        centers[i] = firstCenter + (usable * i) / (sorted.length - 1);
                    }
                }

                for (let i = 1; i < sorted.length - 1; i++) {
                    sorted[i].style.left = `${centers[i]}px`;
                    sorted[i].style.right = 'auto';
                    sorted[i].style.transform = 'translateX(-50%)';
                }
            }

            // Re-pin ends so nothing moved them
            firstMark.style.left = '0';
            firstMark.style.right = 'auto';
            firstMark.style.transform = 'none';
            lastMark.style.left = 'auto';
            lastMark.style.right = '0';
            lastMark.style.transform = 'none';

            this.resolveLabelTextCollisions(sorted);
        }

        resolveLabelTextCollisions(marks) {
            const sorted = [...marks].sort(
                (a, b) => (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0)
            );
            const gap = 8;

            for (let i = 1; i < sorted.length; i++) {
                const prevText = sorted[i - 1].querySelector('.cart-slide__label-text');
                const currText = sorted[i].querySelector('.cart-slide__label-text');
                if (!prevText || !currText) continue;

                const prevRect = prevText.getBoundingClientRect();
                const currRect = currText.getBoundingClientRect();
                if (currRect.left >= prevRect.right + gap) continue;

                const shift = prevRect.right + gap - currRect.left;
                const match = (currText.style.transform || '').match(/translateX\(([-\d.]+)px\)/);
                const existing = match ? parseFloat(match[1]) : 0;
                currText.style.transform = `translateX(${existing + shift}px)`;
            }
        }
    });
}

document.addEventListener('cart:updated', (e) => {
    const cart = e.detail;
    if (!cart) return;
    document.querySelectorAll('shipping-bar').forEach((bar) => {
        if (typeof bar.updateFromCart === 'function') {
            bar.updateFromCart(cart);
        }
    });
});
